<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div _ngcontent-c5="" class="float-left size" id="viewCmsStuiod">
  <!-- <div class="page-contents" style="background: #E5E5E5">
    <div class="levelOne-full-container" id='levelOne' style="min-width:960px;border-right: 0">
      <div style="width:960px" class="float-left">
        <div class="pageTitle">
          {{title}}
          <i class="material-icons pullfloat-right" [routerLink]="['/home']">close</i>
        </div>

        <div style="height: calc(100vh - 105px);">
          <div (click)="clickEvent($event)" [innerHTML]="cms?.innerHtml | sanitizeHtml" class="p-2" style="height: calc(100vh - 105px);overflow-y: auto;">
          </div>
        </div>
      </div> -->

  <div id="viewCmsStuiod" class="float-left"
    [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}"
    [style.zIndex]="cms?.subPages?.length + 1">
    <div class="subBlockContent">
      <child-header [title]="cms?.title" (closeEvent)="close()"></child-header>
      <div class="child-body">
        <div class="inner-subBlock-wrapper">
        <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{cms?.title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->
        <div *ngIf="cms && cms.innerHtml" class="fr-view">
          <span [innerHTML]="cms?.innerHtml | sanitizeHtml" (click)="clickEvent($event)"></span>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <ng-container *ngFor="let cml of cms?.subPages; let i = index">
    <div class="ax-ver-nav" [style.background-color]="getBackgroundColor(i)" [style.zIndex]="cms?.subPages?.length - i"
      (click)="viewNavigation(i)" [class.hide]="viewNavIndex != null">
      <h6>{{cml.title}}</h6>
    </div>
    <div class="float-left" *ngIf="viewNavIndex == i" style="width: 906px; background: #fff; height: 100%;border-left:1px solid #dee2e6">
      <div class="pageTitle">
        {{cml.title}}
        <i class="material-icons pullfloat-right" (click)="viewNavIndex = null;openViewStudio();">close</i>
      </div>
      <div class="col-md-12" style="height: calc(100vh - 105px);overflow: auto">
        <div [innerHtml]="cml?.innerHtml | sanitizeHtml" (click)="clickEvent($event)"></div>
      </div>
    </div>
  </ng-container> -->

<!-- </div> -->
<!-- </div>
</div> -->